import React from 'react'

// assets
import Back from '../../assets/back.svg'
import Cancel from '../../assets/cancel.svg'

const Button = ({name, className, disabled, click, color, asEl, type}) => {
  const col = disabled ? 'bg-grey' : (color === 'dark' ? 'bg-grey-black' : (color === 'grey' ? 'bg-grey-darkest' : (color === 'red' ? 'bg-red' : 'bg-grey-black')))
  const Tag = asEl ? asEl : 'button'
  const classes = type === 'back' ? `back-button rounded-full bg-grey-lightest flex items-center sm:p-0 p-4 justify-center${ className ? ' ' + className : ''}`
  : type === 'cancel' ? `cancel-button rounded-full bg-grey-lightest flex items-center sm:p-0 p-4 justify-center${ className ? ' ' + className : ''}`:
  `min-w-10 justify-center xxl:px-12 px-6 xxl:h-17 h-14 rounded-full text-center text-white text-sm font-normal${ className ? ' ' + className : ''} ${col}${disabled ? ' pointer-events-none' : ''}`
  return (
    <Tag
      className={classes}
      onClick={click || (() => {})}
    >
      {type === 'back' ? <img src={Back} className="w-4" alt="Back" /> : type === 'cancel' ? <img src={Cancel} className="w-4" alt="Cancel" /> : name}
    </Tag>
  )
}

export default Button
